<div class="login-wrapper">
  <div class="login-card">
    <header class="login-header">
      <div class="login-logo" aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          width="28"
          height="28"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>

      <h1 class="login-title">Вход в систему</h1>
      <p class="login-subtitle">Введите свои данные, чтобы продолжить</p>
    </header>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
      <div
        *ngIf="errorMessage"
        class="login-error"
        role="alert"
        aria-live="polite"
      >
        {{ errorMessage }}
      </div>

      <div class="form-group">
        <label for="username">Имя пользователя</label>

        <input
          id="username"
          type="text"
          class="form-control"
          formControlName="username"
          autocomplete="username"
          inputmode="text"
          enterkeyhint="next"
          spellcheck="false"
          [attr.aria-invalid]="isInvalid('username')"
          [attr.aria-describedby]="isInvalid('username') ? 'username-error' : null"
        />

        <small
          id="username-error"
          class="field-error"
          *ngIf="isInvalid('username')"
        >
          Укажите имя пользователя
        </small>
      </div>

      <div class="form-group">
        <label for="password">Пароль</label>

        <div class="password-wrap">
          <input
            id="password"
            [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            formControlName="password"
            autocomplete="current-password"
            enterkeyhint="go"
            [attr.aria-invalid]="isInvalid('password')"
            [attr.aria-describedby]="isInvalid('password') ? 'password-error' : null"
          />

          <button
            type="button"
            class="password-toggle"
            (click)="togglePassword()"
            [attr.aria-label]="showPassword ? 'Скрыть пароль' : 'Показать пароль'"
            [attr.aria-pressed]="showPassword"
          >
            <svg
              *ngIf="!showPassword"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>

            <svg
              *ngIf="showPassword"
              viewBox="0 0 24 24"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
              <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
              <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
              <line x1="1" y1="1" x2="23" y2="23" />
            </svg>
          </button>
        </div>

        <small
          id="password-error"
          class="field-error"
          *ngIf="isInvalid('password')"
        >
          Введите пароль
        </small>
      </div>

      <div class="login-submit">
        <button
          type="submit"
          class="login-submit-btn"
          [disabled]="loginForm.invalid || isLoading"
          [attr.aria-busy]="isLoading"
        >
          <span *ngIf="!isLoading">Войти</span>

          <span *ngIf="isLoading" class="btn-loading">
            <span class="spinner" aria-hidden="true"></span>
            <span>Вход...</span>
          </span>
        </button>
      </div>
    </form>
  </div>
</div>
